/* eslint-disable @typescript-eslint/naming-convention */
import { FileIngestionResults } from '@ouster/webviz-react-components';

import { BASE_ORG_API } from './constants';
import { fetchWithAuth } from './requests';
import { DataCategory, Tag } from '../types';

/**
 *
 * @param selectedTags
 * @param uploadSessionID
 * @param dataCategory
 * @param configInfo
 */
export function translateDict(
  selectedTags: Tag[],
  uploadSessionID?: string,
  dataCategory?: DataCategory,
  configInfo?: Array<FileIngestionResults>
) {
  const bucket =
    localStorage.getItem('source_bucket') ??
    `${process.env.REACT_APP_SOURCE_BUCKET}`;

  const sdk_info = {
    data_type: 'SDK',
    source_bucket: bucket,
    source_prefix: `final/${uploadSessionID}/`,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    data_category_id: dataCategory!.id,
    tag_ids: selectedTags.map((tag) => tag.id),
    upload_status: 'NOT_STARTED',
  };

  const translate_dict: Record<string, string> = {
    build_date: 'sdk_fw_build_date',
    build_rev: 'sdk_fw_build_rev',
    fw_branch: 'sdk_fw_branch',
    fw_commit_hash: 'sdk_fw_commit_hash',
    fw_merge_request: 'sdk_fw_merge_request',
    fw_version_core: 'sdk_fw_version_core',
    fw_version_prerelease: 'sdk_fw_version_prerelease',
    image_rev: 'sdk_fw_image_rev',
    lidar_mode: 'sdk_lidar_mode',
    prod_beam_spacing: 'sdk_prod_beam_spacing',
    prod_generation: 'sdk_prod_generation',
    prod_hw_rev: 'sdk_prod_hw_rev',
    prod_line: 'sdk_prod_line',
    prod_pn: 'sdk_prod_pn',
    prod_resolution: 'sdk_prod_resolution',
    prod_sn: 'sdk_prod_sn',
    prod_type: 'sdk_prod_type',
  };

  if (!Array.isArray(configInfo)) return {};
  const sensor_info = configInfo.map((ingestion_result) => {
    const translated: Record<string, any> = {};

    Object.keys(ingestion_result).forEach((key) => {
      if (key in translate_dict) {
        translated[translate_dict[key]] =
          ingestion_result[key as keyof FileIngestionResults];
      } else {
        translated[key] = ingestion_result[key as keyof FileIngestionResults];
      }
    });

    return translated;
  });

  return {
    ...sdk_info,
    sensor_info,
  };
}

export async function getFilesByUploadId(
  uploadSessionID: string,
  orgId: number
): Promise<FileIngestionResults[]> {
  const resp = await fetchWithAuth(
    `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }
  );

  const data = (await resp.json()) as {
    files?: Array<{ ingestion_result: FileIngestionResults }>;
  };
  // Extract ingestion_result from each file
  return data.files?.map((file) => file.ingestion_result) ?? [];
}

// Creates drive before submitting data
/**
 *
 * @param selectedTags
 * @param orgId
 * @param uploadSessionID
 * @param dataCategory
 * @param configInfo
 */
export async function createDrive(
  selectedTags: Tag[],
  orgId: number,
  uploadSessionID?: string,
  dataCategory?: DataCategory,
  configInfo?: Array<FileIngestionResults>
) {
  // create drive from dictionary
  const translated_dict = translateDict(
    selectedTags,
    uploadSessionID,
    dataCategory,
    configInfo
  );

  return fetchWithAuth(`${BASE_ORG_API}/${orgId}/recordings/`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(translated_dict),
  }).catch((err) => {
    console.warn(`Failed to create drive for session ${uploadSessionID}`);
    console.warn(err);
  });
}
